<ng-container *ngIf="title">
  <div class="row">
    <div class="col">
      <h2>
        {{title}}
      </h2>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="subTitle">
  <div class="row">
    <div class="col">
      <p>
        {{subTitle}}
      </p>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="branch">
  <div class="row">
    <div class="col">
      <p>
        <b>Branch:</b>&nbsp;{{branch}}
      </p>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="revision">
  <div class="row">
    <div class="col">
      <p>
        <b>Revision:</b>&nbsp;{{revision}}
      </p>
    </div>
  </div>
</ng-container>

<hr *ngIf="title || subTitle || revision || branch">

<ng-container *ngIf="changeLog">
  <h4>
    Changelog
  </h4>
  <div class="row">
    <div class="col">
      <div style="max-height: 300px; overflow-x: hidden; overflow-y: scroll;">
        <ul>
          <hr class="border-dashed">
          <ng-container *ngFor="let item of changeLog">
            <li>
              {{item}}
            </li>
            <hr class="border-dashed">
          </ng-container>
        </ul>
      </div>
    </div>
  </div>
</ng-container>

<hr>
